module.exports = __webpack_public_path__ + "img/nomonitoring.52cb738d.svg";